module.exports = __webpack_public_path__ + "static/media/buttonsounds10.ff1429ca.wav";